import { when, makeObservable, actionBound } from "mobx";
import GlobalStore from "@/store";
import ShopType from "@/enum/ShopType";

class ChannelShopSDKStore {
    constructor(public globalStore: typeof GlobalStore) {
        makeObservable(this, {
            init: actionBound,
            initQuantityInspectionCodeSDK: actionBound,
        });
        this.init();
    }

    async init() {
        if (import.meta.env.VITE_IS_QN) return;

        await when(() => this.globalStore.isInit);

        this.initQuantityInspectionCodeSDK();
    }

    async initQuantityInspectionCodeSDK() {
        const hasChannelShop = this.globalStore.allowedShops?.some(({ type }) =>
            [ShopType.CHANNEL_SHOP, ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(type),
        );

        if (!hasChannelShop) return;
    }
}

export default ChannelShopSDKStore;
